import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./region-summary-popup.module.scss";
import {
    selectActiveFeature,
    selectFilteredProjectsInActiveFeature,
} from "../../reducers/";

const Text = ({ numOfProjets, activeFeature, nameSelector }) => {
    const projectGrammar = numOfProjets > 1 ? "projects" : "project";

    if (activeFeature) {
        return (
            <p className={styles.paragraph}>
                <strong>{numOfProjets}</strong> {projectGrammar} in the{" "}
                {nameSelector(activeFeature)} Electorate received funding for My
                Community Project.
            </p>
        );
    }

    return (
        <p className={styles.paragraph}>
            <strong>{numOfProjets}</strong> were successful in the public vote
            for My Community Project.
        </p>
    );
};
Text.propTypes = {
    numOfProjets: PropTypes.number.isRequired,
    activeFeature: PropTypes.object,
    nameSelector: PropTypes.func.isRequired,
};
function RegionSummaryPopup({ projects, activeFeature, nameSelector }) {
    const length = projects.length;
    return (
        <div className={styles.container}>
            <Text
                numOfProjets={length}
                activeFeature={activeFeature}
                nameSelector={nameSelector}
            />
            {activeFeature ? (
                <p className={styles.paragraph}>
                    Click on {length > 1 ? "a" : "the"} pin to find more about
                    the project.
                </p>
            ) : (
                <p className={styles.paragraph}>
                    Click on an electorate to find more about the projects in
                    that area.
                </p>
            )}
        </div>
    );
}
RegionSummaryPopup.propTypes = {
    nameSelector: PropTypes.func.isRequired,
    activeFeature: PropTypes.object,
    projects: PropTypes.array,
};
export default connect(state => {
    return {
        activeFeature: selectActiveFeature(state),
        projects: selectFilteredProjectsInActiveFeature(state),
    };
})(RegionSummaryPopup);



// WEBPACK FOOTER //
// ./src/components/region-summary-popup/region-summary-popup.js